<template>
  <div class="container">
    <div class="center_out h-full">
      <div class="card login-card">
        <div class="login-card-1" id="login-card-1"></div>
        <div class="login-card-2">
          <img src="/images/logo.svg" alt="" />
          <div class="card-inner">
            <div v-if="loading" class="text-center">
              <p>Anmeldung wird verarbeitet...</p>
              <div class="spinner mt-3"></div>
            </div>

            <div v-if="error" class="text-center">
              <vs-alert color="danger" class="mt-4">
                <strong>Fehler bei der Anmeldung</strong>
                <p>{{ errorMessage }}</p>
              </vs-alert>

              <div class="mt-4">
                <button @click="goToLogin" class="from-btn">
                  Zurück zur Anmeldung
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <small class="version mt-3">Version: {{ version }}</small>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
  name: "LoginCallback",

  data() {
    return {
      loading: true,
      error: false,
      errorMessage: "",
    };
  },

  computed: {
    version() {
      if (GIT_DESCRIBE !== null) {
        return GIT_DESCRIBE.tag + " - " + GIT_DESCRIBE.hash;
      } else {
        return "no-version";
      }
    },
  },

  async mounted() {
    await this.handleCallback();
  },

  methods: {
    async handleCallback() {
      // Complete Keycloak login using keycloak-js
      try {
        await this.$store.dispatch("auth/completeKeycloakLogin");

        // Check if authenticated
        if (await this.$store.dispatch("auth/isAuthenticated")) {
          const everLoggedIn = localStorage.getItem("bos_ever_logged_in");
          const logoutClean = localStorage.getItem("bos_logout_clean");
          const showWarning = !!(everLoggedIn && !logoutClean);
          localStorage.removeItem("bos_logout_clean");
          localStorage.setItem("bos_ever_logged_in", "1");

          this.$vs.notify({
            color: "success",
            position: "bottom-right",
            title: "Willkommen im BOS-ID Portal",
            text: "Erfolgreich mit Keycloak angemeldet",
          });

          // Redirect to dashboard
          this.$router.push({ path: "/dashboard", query: showWarning ? { session_warning: "1" } : {} });
        } else {
          throw new Error("Authentifizierung fehlgeschlagen");
        }
      } catch (e) {
        this.error = true;
        this.errorMessage = e.message || "Unbekannter Fehler";
      } finally {
        this.loading = false; // ✅ war vorher außerhalb des try-catch
      }
    },

    goToLogin() {
      this.$router.push({ name: "Login" });
    },
  },
});
</script>

<style scoped>
#login-card-1 {
  background: url("../../public/images/login-image.png");
  min-height: 100%;
  max-height: 30vh;
  background-repeat: no-repeat;
  background-position: center 25%;
  -webkit-background-size: 100%;
  -moz-background-size: 100%;
  -o-background-size: 100%;
  background-size: 100%;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}

.version {
  font-size: 0.75em;
  color: rgb(202, 202, 202);
}

.spinner {
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.text-center {
  text-align: center;
}

.mt-3 {
  margin-top: 1rem;
}

.mt-4 {
  margin-top: 1.5rem;
}
</style>
